import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#101828",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M8.75 12.833H5.368c-.653 0-.98 0-1.23.127-.219.112-.397.29-.51.51-.126.25-.126.577-.126 1.23v9.8m15.75-11.667h3.383c.653 0 .98 0 1.23.127.22.112.398.29.51.51.127.25.127.577.127 1.23v9.8m-5.25 0V7.233c0-1.306 0-1.96-.255-2.459a2.333 2.333 0 0 0-1.02-1.02c-.498-.254-1.152-.254-2.459-.254h-3.033c-1.307 0-1.96 0-2.46.254-.438.224-.795.581-1.019 1.02-.254.5-.254 1.153-.254 2.46V24.5m16.916 0H2.334m10.5-16.333h2.333m-2.333 4.666h2.333M12.834 17.5h2.333"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "building"}) } }